import { render } from "./InOnLaysDifference.vue?vue&type=template&id=5b2a44fa"
import script from "./InOnLaysDifference.vue?vue&type=script&lang=js"
export * from "./InOnLaysDifference.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__